'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuItemSwitch", {
    enumerable: true,
    get: function() {
        return MenuItemSwitch;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useMenuItemSwitch = require("./useMenuItemSwitch");
const _renderMenuItemSwitch = require("./renderMenuItemSwitch");
const _useMenuItemSwitchStylesstyles = require("./useMenuItemSwitchStyles.styles");
const MenuItemSwitch = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuItemSwitch.useMenuItemSwitch_unstable)(props, ref);
    (0, _useMenuItemSwitchStylesstyles.useMenuItemSwitchStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuItemSwitchStyles_unstable')(state);
    return (0, _renderMenuItemSwitch.renderMenuItemSwitch_unstable)(state);
});
MenuItemSwitch.displayName = 'MenuItemSwitch';
